import Paginate from "./Paginate";

export {
    Paginate
}
